import Meta from '@/components/Meta';
import { AnimatePresence, motion } from 'framer-motion';
import contentTexture from '/public/homepage/paper-texture.png';
import { cleanParkData } from '@/lib/util';

import HomepageHero from '@/components/HomepageHero';
import FeaturedParks from '@/components/FeaturedParks';
import FeaturedEvents from '@/components/FeaturedEvents';
import HeadingStyle from '@/components/HeadingStyle';
import EventItemsGrid from '@/components/EventItemsGrid';
import useSWR from 'swr';
import { filterOutClosureEvents, getEventsAndSortByDate } from '@/lib/data';
import { getAllParks, getAllEvents } from '@/lib/db-queries';
import Link from 'next/link';
import { ArrowLongRightIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Button from '@/components/Button';

export default function Home({ events, parks }) {
  //const { data: parks, isLoading, error } = useSWR('/api/parks');
  //console.log(parks[1])
  //const designations = [...new Set(parks.map(park => park.designation))];
  //console.log(designations)
  const [width, setWidth] = useState(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    const handleResize = () => setWidth(window.innerWidth);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Only calculate isListView after client hydration to prevent mismatch
  // Default to false (mobile/card view) for SSR, then update on client
  const isListView = isClient && width !== null && width >= 768;

  return (
    <>
      <Meta title="My National Parks" />
      <main className="">
        <HomepageHero parks={parks} />

        <div className="relative">
          {/*<Image src={contentTexture} alt="" width="1440" height="303" className="absolute -top-[100px] md:-top-[140px] lg:-top-[180px] w-full z-0" placeholder="blur" />*/}
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
            className="max-w-8xl mx-auto my-5 px-4 sm:px-6 md:px-8 relative z-1"
          >
            <FeaturedParks parks={parks} />
          </motion.section>
        </div>

        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="max-w-8xl mx-auto my-5 px-4 sm:px-6 md:px-8"
        >
          <EventItemsGrid
            events={events.slice(0, 10)}
            isListView={isListView}
            gridClassNames={'my-5 grid gap-6 my-5 grid-cols-1'}
            headingClassNames="mt-10 text-4xl"
            showHeading
            headingText="Upcoming Events"
          />
          <Button
            href="/events"
            variant="primary"
            size="lg"
            icon={
              <ArrowLongRightIcon width={25} className="pointer-events-none" />
            }
            iconPosition="right"
          >
            Find an event
          </Button>
        </motion.section>

        {/*<NearbyParks parks={parks} />*/}
        {/*<NearbyEvents parks={parks} />*/}
        {/*<FeaturedParks parks={parks} />*/}
        {/*<section className={`max-w-8xl mx-auto my-5 px-4 sm:px-6 md:px-8`}>
                <h2 className={`text-4xl`}>Recent NPS Articles</h2>
            </section>*/}
      </main>
    </>
  );
}

export async function getStaticProps() {
  try {
    // Fetch from Supabase database
    const [parksData, eventsData] = await Promise.all([
      getAllParks(),
      getAllEvents(),
    ]);

    // Filter and sort events
    let events = filterOutClosureEvents(eventsData);
    events = getEventsAndSortByDate(events, true);

    // Clean the data to remove undefined values that can't be serialized
    const cleanedParks = parksData.map((park) => cleanParkData(park));
    const cleanedEvents = events.map((event) => cleanParkData(event));

    return {
      props: {
        events: cleanedEvents,
        parks: cleanedParks,
      },
      revalidate: 86400, // Regenerate every 24 hours (data syncs weekly)
    };
  } catch (error) {
    console.error('Error fetching data:', error);
    return {
      props: {
        events: [],
        parks: [],
      },
      revalidate: 60, // Retry sooner on error
    };
  }
}
